/*
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class KidsService {
  private apiUrl = environment.backClient;

  constructor(private http: HttpClient, private authService: AuthService) {}

  private getParentId(): string {
    return this.authService.getUserFromStorage()?.sub || '';
  }

  private getHeaders(): HttpHeaders {
    return new HttpHeaders({ Authorization: `Bearer ${this.authService.getToken()}` });
  }
  updateKidStatus(kidId: string, isActive: boolean): Observable<any> {
    const parentId = this.getParentId();
    return this.http.put<any>(
      `${this.apiUrl}/merchant/${parentId}/kids/${kidId}/status`,
      { active: isActive },
      { headers: this.getHeaders() }
    );
  }
  // Dans kids.service.ts

  deleteKid(kidCustomerId: string): Observable<any> {
    const parentId = this.getParentId();
    // Utilisation de la méthode DELETE avec l'URL structurée
    return this.http.delete(
      `${this.apiUrl}/merchant/${parentId}/kids/${kidCustomerId}`,
      { headers: this.getHeaders() }
    );
  }
  getKids(): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/merchant/${this.getParentId()}/kids`, {
      headers: this.getHeaders()
    });
  }

  addKid(kid: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/merchant/${this.getParentId()}/kids`, kid, {
      headers: this.getHeaders()
    });
  }
  getCategories(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/merchant/categories`, {
      headers: this.getHeaders()
    });
  }

}
*/
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class KidsService {
  private apiUrl = environment.backClient;

  constructor(private http: HttpClient, private authService: AuthService) {}

  private getParentId(): string {
    return this.authService.getUserFromStorage()?.sub || '';
  }

  private getHeaders(): HttpHeaders {
    return new HttpHeaders({ Authorization: `Bearer ${this.authService.getToken()}` });
  }

  // --- NOUVEAU : Récupère les vrais types de tickets (Label, ID) ---
  getTickets(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/tickets`, {
      headers: this.getHeaders()
    });
  }

  getKids(): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/merchant/${this.getParentId()}/kids`, {
      headers: this.getHeaders()
    });
  }

  addKid(kid: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/merchant/${this.getParentId()}/kids`, kid, {
      headers: this.getHeaders()
    });
  }

  updateKidStatus(kidId: string, isActive: boolean): Observable<any> {
    const parentId = this.getParentId();
    return this.http.put<any>(
      `${this.apiUrl}/merchant/${parentId}/kids/${kidId}/status`,
      { active: isActive },
      { headers: this.getHeaders() }
    );
  }

  /*deleteKid(kidCustomerId: string): Observable<any> {
    const parentId = this.getParentId();
    return this.http.delete(
      `${this.apiUrl}/merchant/${parentId}/kids/${kidCustomerId}`,
      { headers: this.getHeaders() }
    );
  }*/
}
